import { render, staticRenderFns } from "./multiple-choice-radio.vue?vue&type=template&id=70a68bf0&scoped=true&"
import script from "./multiple-choice-radio.vue?vue&type=script&lang=js&"
export * from "./multiple-choice-radio.vue?vue&type=script&lang=js&"
import style0 from "./multiple-choice-radio.vue?vue&type=style&index=0&id=70a68bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a68bf0",
  null
  
)

export default component.exports